function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.ga = {}));
})(this, function (exports) {
  'use strict';

  var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
    l10ns: {}
  };
  var Irish = {
    firstDayOfWeek: 1,
    weekdays: {
      shorthand: ["Dom", "Lua", "Mái", "Céa", "Déa", "Aoi", "Sat"],
      longhand: ["Dé Domhnaigh", "Dé Luain", "Dé Máirt", "Dé Céadaoin", "Déardaoin", "Dé hAoine", "Dé Sathairn"]
    },
    months: {
      shorthand: ["Ean", "Fea", "Már", "Aib", "Bea", "Mei", "Iúi", "Lún", "MFo", "DFo", "Sam", "Nol"],
      longhand: ["Eanáir", "Feabhra", "Márta", "Aibreán", "Bealtaine", "Meitheamh", "Iúil", "Lúnasa", "Meán Fómhair", "Deireadh Fómhair", "Samhain", "Nollaig"]
    },
    time_24hr: true
  };
  fp.l10ns.hr = Irish;
  var ga = fp.l10ns;
  exports.Irish = Irish;
  exports.default = ga;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});